import React, { useRef, useState } from 'react';
import Rodal from '../../../../../components/Rodal/Rodal';
import { ModalBody, ModalHeader } from 'reactstrap';
import createNotification from '../../../../../utils/createNotification';
import { useStateSelector } from '../../../../../store/selectors';
import { useDispatch } from 'react-redux';
import { GetTimelineById } from '../../../../../slices/marketplace/timeline/thunks/get-timeline-by-id.thunk';
import { EngagementDocument } from '../../../../../slices/marketplace/timeline/models/engagement-document';
import ButtonLoader from '../../../../../components/Layout/Buttons/ButtonLoader';
import * as yup from 'yup';
import { Formik } from 'formik';
import { Field } from '@availity/form';
import './EditDocumentNamePopup.scss';

interface EditDocumentNamePopupProps {
    engagementId: number;
    document: EngagementDocument;
    isVisible: boolean;
    onClose(value: boolean): void;
    onRenamed?(): void;
}

const EditDocumentNamePopup = (props: EditDocumentNamePopupProps) => {
    const formRef = useRef<any>();
    const dispatch = useDispatch() as any;
    const axios = useStateSelector((state) => state.core.axios);
    const [isUpdatingName, setIsUploadingDocument] = useState(false);
    const handleSave = (name: string) => {
        setIsUploadingDocument(true);
        axios
            .put(
                `/api/Marketplace/Engagements/${props.engagementId}/documents/${props.document.id}/name`,
                name,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            .then((response: any) => {
                if (response && response.status === 200) {
                    createNotification(
                        'Document Name was successfully updated.',
                        'success'
                    );
                    dispatch(
                        GetTimelineById({
                            id: props.engagementId,
                            isTemplate: false,
                        })
                    );
                    props.onRenamed?.();
                    props.onClose(false);
                } else {
                    const message = response.response.data.title;
                    createNotification(message || '', 'error');
                }
            })
            .catch((error) => {
                createNotification(error.message, 'error');
            })
            .finally(() => {
                setIsUploadingDocument(false);
            });
    };

    return (
        <div className="edit-document-name-popup-container">
            <Rodal
                visible={props.isVisible}
                onClose={() => props.onClose(false)}
                animation="slideUp"
                className="edit-document-name-popup"
                showMask={true}
                width={500}
                showCloseButton={true}>
                <ModalHeader>
                    <b>Edit Document Name</b>
                </ModalHeader>
                <ModalBody>
                    <Formik
                        innerRef={formRef}
                        initialValues={{
                            documentName: props.document?.name || '',
                        }}
                        validationSchema={yup.object().shape({
                            documentName: yup
                                .string()
                                .trim()
                                .required('Document name is required'),
                        })}
                        onSubmit={async (values) => {
                            handleSave(values.documentName);
                        }}>
                        <div>
                            <Field
                                className="field"
                                name="documentName"
                                label="New Document Name"
                            />
                        </div>
                    </Formik>

                    <div className="mt-auto d-flex justify-content-end buttons-container">
                        <button
                            className="btn btn-outline-secondary mr-2"
                            onClick={() => {
                                props.onClose(false);
                            }}>
                            Cancel
                        </button>
                        <ButtonLoader
                            type="submit"
                            buttonText={'Save'}
                            loaderButtonText={''}
                            isLoading={isUpdatingName}
                            disabled={false}
                            onClick={() => {
                                formRef?.current?.handleSubmit();
                            }}
                            className={'btn btn-primary'}
                        />
                    </div>
                </ModalBody>
            </Rodal>
        </div>
    );
};

export default EditDocumentNamePopup;
